module.exports = __webpack_public_path__ + "img/avatar_heisenberg.537e0664.svg";